// using ES6 modules
import { createBrowserHistory } from 'history';
import { createContext } from 'react';


export default createContext(createBrowserHistory())